import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './http/request'
import store from './store'
import Vant from 'vant';
import moment from "moment"
import './assets/style/global.less'
import 'vant/lib/index.css';
import {Table, InfiniteScroll, TableColumn} from 'element-ui'
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import 'amfe-flexible';
// 引入微信 js-sdk
import wx from "weixin-js-sdk";

// import '@/utils/rem.js'
import { Toast } from 'vant'
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false

Vue.use(Vant);
Vue.use(Table);
Vue.use(InfiniteScroll)
Vue.use(TableColumn)
Vue.use(elTableInfiniteScroll)
Vue.use(VueClipboard);
Vue.prototype.$http = http
Vue.prototype.$moment = moment
Vue.prototype.$wx = wx
Vue.prototype.$toast = Toast

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
